
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const SideArrow = () => {
    return (
        <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_165_52)">
            <path d="M19.6667 10C22.2304 10 24.6892 11.0185 26.502 12.8313C28.3149 14.6442 29.3333 17.1029 29.3333 19.6667C29.3333 22.2305 28.3149 24.6892 26.502 26.5021C24.6892 28.3149 22.2304 29.3334 19.6667 29.3334C17.1029 29.3334 14.6442 28.3149 12.8313 26.5021C11.0184 24.6892 10 22.2305 10 19.6667C10 17.1029 11.0184 14.6442 12.8313 12.8313C14.6442 11.0185 17.1029 10 19.6667 10ZM15.4375 19.0625C15.2773 19.0625 15.1236 19.1262 15.0103 19.2395C14.897 19.3528 14.8333 19.5065 14.8333 19.6667C14.8333 19.8269 14.897 19.9806 15.0103 20.0939C15.1236 20.2072 15.2773 20.2709 15.4375 20.2709H22.4374L19.8431 22.864C19.7296 22.9774 19.6659 23.1313 19.6659 23.2917C19.6659 23.4521 19.7296 23.606 19.8431 23.7195C19.9565 23.8329 20.1104 23.8966 20.2708 23.8966C20.4313 23.8966 20.5851 23.8329 20.6986 23.7195L24.3236 20.0945C24.3798 20.0383 24.4245 19.9717 24.4549 19.8983C24.4854 19.8249 24.5011 19.7462 24.5011 19.6667C24.5011 19.5872 24.4854 19.5086 24.4549 19.4352C24.4245 19.3617 24.3798 19.2951 24.3236 19.239L20.6986 15.614C20.5851 15.5005 20.4313 15.4368 20.2708 15.4368C20.1104 15.4368 19.9565 15.5005 19.8431 15.614C19.7296 15.7274 19.6659 15.8813 19.6659 16.0417C19.6659 16.2021 19.7296 16.356 19.8431 16.4695L22.4374 19.0625H15.4375Z" fill="white"/>
            </g>
            <circle cx="19.5" cy="19.5" r="19.5" fill="#F82B60" fillOpacity="0.63"/>
            <defs>
            <clipPath id="clip0_165_52">
            <rect width="19.3333" height="19.3333" fill="white" transform="translate(10 29.3334) rotate(-90)"/>
            </clipPath>
            </defs>
        </svg>
    )
}
const Goals = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 });
    })
    
    return (
        <section className="About">
            <div className="goal__glow"></div>
            <div className="goal__glow2"></div>
            <p data-aos="fade-up">
                <strong>LadscatchNFT</strong> is an NFT ticketing marketplace where people can issue event tickets and other collectable assets as NFTs. We're helping increase the connectivity between artists, fans, event organisers and brands to create a more immersive experience for event-goers. For the first time, artists and event organisers can create real value from their relationships with attendees by identifying and rewarding loyalty and event attendance with collectable NFTs and real-life rewards. 
            </p>
            <div className="about__goal">
                <div className="about__goal__item" data-aos="zoom-in">
                    <h4>Lorem ipsum dolor</h4>
                    <p>Foster a much closer connection between artists, fans, event organisers and brands by incentivising and rewarding fans with NFT collectibles, real-life experiences and making events more immersive.</p>
                    <span>
                        <SideArrow />
                    </span>
                </div>
                <div className="about__goal__item" data-aos="zoom-in" data-aos-delay="200">
                    <h4>Lorem ipsum dolor</h4>
                    <p>Foster a much closer connection between artists, fans, event organisers and brands by incentivising and rewarding fans with NFT collectibles, real-life experiences and making events more immersive.</p>
                    <span>
                        <SideArrow />
                    </span>
                </div>
                <div className="about__goal__item" data-aos="zoom-in" data-aos-delay="200">
                    <h4>Lorem ipsum dolor</h4>
                    <p>Foster a much closer connection between artists, fans, event organisers and brands by incentivising and rewarding fans with NFT collectibles, real-life experiences and making events more immersive.</p>
                    <span>
                        <SideArrow />
                    </span>
                </div>
                <div className="about__goal__item" data-aos="zoom-in" data-aos-delay="200">
                    <h4>Lorem ipsum dolor</h4>
                    <p>Foster a much closer connection between artists, fans, event organisers and brands by incentivising and rewarding fans with NFT collectibles, real-life experiences and making events more immersive.</p>
                    <span>
                        <SideArrow />
                    </span>
                </div>
            </div>
        </section>
    )
}

export default Goals;